export default class PostsFilter {

  constructor (select) {
    this.select = select
    this.customSelect = select.closest('.custom-select')
    this.post_type = this.customSelect.getAttribute('data-post-type')
    this.taxonomy_id = select.value
    this.posts_list_section = this.customSelect.closest('section')
    this.posts_list = this.posts_list_section.querySelector('.posts-list')
    this.posts_list_count = this.posts_list_section.querySelector('.posts-list-count')

    this.loadPostsData()

  }

  loadPostsData() {
    const self = this
    const formData = new FormData()
    formData.append('action','filter_posts');
    formData.append('post_type', this.post_type)
    formData.append('taxonomy_id', this.taxonomy_id)

    // send ajax request
    $.ajax({
      type: 'POST',
      url: localize_script.admin_ajax,
      data: formData,
      async: false,
      cache: false,
      contentType: false,
      enctype: 'multipart/form-data',
      processData: false,
      success: function (results) {

        self.posts_list.innerHTML = results.html
        self.posts_list_count.innerHTML = results.count


      },
    })


  }

}
